import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.showSelectedTab()
    $(this.tabLinks).on("shown.bs.tab", this.preserveTabState.bind(this))
    this.boundRestoreTabHash = this.restoreTabHash.bind(this)
    document.addEventListener("turbo:frame-render", this.boundRestoreTabHash) // fires for all frames; restoreTabHash is a no-op when the hash is still present
    if (window.location.hash) {
      this._activeTabHash = window.location.hash.endsWith("-tab")
        ? window.location.hash
        : window.location.hash + "-tab"
    }
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this.boundRestoreTabHash)
  }

  showSelectedTab() {
    const tabStateHash = window.location.hash.replace("-tab", "")
    $(this.element.querySelector(`a[href='${tabStateHash}']`)).tab("show")
  }

  handleSelectTabEvent({ detail: { tab } }) {
    $(this.element.querySelector(`a[href='#${tab}']`)).tab("show")
  }

  get tabLinks() {
    return this.element.querySelectorAll("a")
  }

  preserveTabState(ev) {
    this._activeTabHash = ev.target.hash + "-tab"
    if (history.pushState) {
      history.pushState(null, null, this._activeTabHash)
    } else {
      window.location.hash = this._activeTabHash
    }
  }

  restoreTabHash() {
    if (!window.location.hash && this._activeTabHash) {
      history.replaceState(
        null,
        null,
        window.location.pathname + window.location.search + this._activeTabHash
      )
    }
  }
}
